import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/group/page`
  return http.post(url, params)
}
// 获取用户列表
const getAuditUsers = () => {
  const url = '/api/v1/users/all'
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/group/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/group/save`
  return http.post(url, params)
}
// 修改禁用启用
const statusAction = (params) => {
  const url = `/market/management/group/changeStatus`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/group/delete/${id}`
  return http.post(url)
}

// 项目组管理分组设置
const groupLogSave = (params) => {
  const url = `/market/common/group/log/save`
  return http.post(url, params)
}

// 项目组管理分组设置列表
const groupLogList = (params) => {
  const url = `/market/common/group/log/list`
  return http.post(url, params)
}

export default {
  searchAction,
  getAuditUsers,
  getGroup,
  getAction,
  addAction,
  statusAction,
  deleteAction,
  groupLogSave,
  groupLogList
}
